import { connect } from 'react-redux';

import Preferences from '../components/Preferences';

import { openDialog } from '../redux/alert';
import { checkPreferences, newPreferences } from '../redux/book';

const mapStateToProps = ({ alert, book, data }) => ({ ...alert, ...book, ...data });

const mapDispatchToProps = dispatch => ({
  checkPreferences: () => dispatch(checkPreferences()),
  openDialog: dialogType => dispatch(openDialog(dialogType)),
  newPreferences: body => dispatch(newPreferences(body)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Preferences);



// WEBPACK FOOTER //
// ./src/containers/Preferences.js